import { useState, useEffect } from "react";
import { Clock } from "lucide-react";

interface CountdownTimerProps {
  targetDate: string;
  targetTime?: string;
  label: string;
}

const CountdownTimer = ({ targetDate, targetTime, label }: CountdownTimerProps) => {
  const [timeLeft, setTimeLeft] = useState({ days: 0, hours: 0, mins: 0 });
  const [expired, setExpired] = useState(false);

  useEffect(() => {
    const target = new Date(`${targetDate}T${targetTime || "21:00:00"}`);
    const update = () => {
      const diff = target.getTime() - Date.now();
      if (diff <= 0) { setExpired(true); return; }
      setTimeLeft({
        days: Math.floor(diff / 86400000),
        hours: Math.floor((diff % 86400000) / 3600000),
        mins: Math.floor((diff % 3600000) / 60000),
      });
    };
    update();
    const interval = setInterval(update, 60000);
    return () => clearInterval(interval);
  }, [targetDate, targetTime]);

  if (expired) return null;

  return (
    <div className="flex items-center gap-3 rounded-xl border border-border bg-card px-4 py-3">
      <Clock className="h-4 w-4 text-primary" />
      <span className="text-xs text-muted-foreground">{label}</span>
      <div className="ml-auto flex gap-2">
        {timeLeft.days > 0 && (
          <div className="text-center">
            <span className="text-sm font-bold text-foreground">{timeLeft.days}</span>
            <span className="text-[10px] text-muted-foreground ml-0.5">d</span>
          </div>
        )}
        <div className="text-center">
          <span className="text-sm font-bold text-foreground">{timeLeft.hours}</span>
          <span className="text-[10px] text-muted-foreground ml-0.5">h</span>
        </div>
        <div className="text-center">
          <span className="text-sm font-bold text-foreground">{timeLeft.mins}</span>
          <span className="text-[10px] text-muted-foreground ml-0.5">m</span>
        </div>
      </div>
    </div>
  );
};

export default CountdownTimer;
